/* =========================================================
  ____    ___    ____   _   __       __                
 |  _ |  / _ \  |  _ \ | | |   \    |   \  ___  __ __  
 |  __| | |_| | |  __/ | | | |) | o | |) |/ -_) \ V /  
 |_|\_\ |_| |_| |_|    |_| |___/    |___/ \___|  \_/  o o o  

========================================================== */

import React, { useEffect, useState } from "react";

// react-router-dom components
import { useParams, NavLink } from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import i18n from "components/Translation/Translate";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import * as Defi from "services/Define";
import { setToken, setUser, setLang, setPerm, setMenu, clearState } from "redux/actions/appAction";
import { PostData } from "services/Request";

// Authentication layout components

// Image
import PageLayout from "examples/LayoutContainers/PageLayout";

function PointOfsale() {
  const mod = "authen";
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const app = useSelector((state) => state[Defi.APP_STATE]);
  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const signIn = (event) => {
    event.preventDefault();

    dispatch(clearState());

    PostData(`/login`, {
      lang: app.lang,
      username: username,
      password: password,
    }).then((result) => {
      if (result.status === "ok") {
        dispatch(setToken(result.token));
        dispatch(setUser(result.user));
        dispatch(setMenu(result.menu));
        dispatch(setLang(result.user.language));

        window.location.replace(result.url);
      }
    });
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);
    // console.log("SignIn", app);

    // register();
  }, []);

  return (
    <PageLayout>
      <NavLink to="/dashboard_admin">
        <MDButton variant="outlined" color="warning">
          <Icon>arrow_back</Icon>&nbsp;{t(`element.back`)}
        </MDButton>
      </NavLink>
    </PageLayout>
  );
}

export default PointOfsale;
